import { render, staticRenderFns } from "./photo-list.vue?vue&type=template&id=2eddc710&scoped=true&lang=pug&"
import script from "./photo-list.vue?vue&type=script&lang=js&"
export * from "./photo-list.vue?vue&type=script&lang=js&"
import style0 from "./photo-list.vue?vue&type=style&index=0&id=2eddc710&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eddc710",
  null
  
)

export default component.exports